import Base from "../Base";

export default class Default extends Base {
  init() {
    console.log("Default :: init");

    if (document.querySelector(".anchor")) {
      const Anchors = document
        .querySelector(".anchor")
        .getElementsByTagName("a");
      console.log(Anchors);
      for (const anchor of Anchors) {
        anchor.addEventListener("click", (e) => {
          this.scroll(e);
        });
      }
    }
  }

  scroll(e) {
    e.preventDefault();
    var id = e.currentTarget.getAttribute("href").replace("#", "");
    var target = document.getElementById(id).getBoundingClientRect().top;
    this.animateScroll(target);
  }

  animateScroll(targetHeight, callback) {
    targetHeight =
      document.body.scrollHeight - window.innerHeight > targetHeight + scrollY
        ? targetHeight
        : document.body.scrollHeight - window.innerHeight;
    var initialPosition = window.scrollY;

    window.scrollTo(0, initialPosition + targetHeight);
  }
}
